import { Injectable } from '@angular/core';
import { SDGComponentService, ResultService, AlertService } from './index';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { SDGComponent, Result } from '../_models/index';

var COMP = environment.component.status;

@Injectable()
export class StatusService {
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<Result[]>;
  grp_map_qtod = {
    '3':2,
    '4':3,
    '5':5,
    '6':7,
    '7':9,
    '8':10,
    '9':11,
    '10':12,
    '12':13,
    '13':14,
    '14':16,
    '15':17,
    '16':18,
    '17':19,
    '18':20,
    '19':21,
    '20':22,
    '21':24,
    '22':25,
    '23':26,
    '24':28,
    '25':29,
    '26':30,
    '27':31,
    '28':32,
    '29':33,
    '30':35,
    '31':37,
    '32':38,
    '33':39
  };
  constructor(
    private sdgComponentService: SDGComponentService,
    private resultService: ResultService,
    private alertService: AlertService) { }

  prepareForStatusResult(): Observable<any> {
    return Observable.create(observer => {
      this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
      this.sdgcomponent$.subscribe( data => {
        var categories = data.category;
        var ordered_categories = [];
        var cl = categories.length;

        //reordering categories based on order field in each categrory
        for(var i = 0; i< cl; i++){
          ordered_categories[categories[i].order-1] = categories[i];
        }
        //reordering sub_categories based on order field in each sub_categrory
        for(var i = 0; i< cl; i++){
          var oc_sc = ordered_categories[i].sub_category;
          var oc_osc = [];
          for(var j = 0; j< oc_sc.length; j++){
              oc_osc[oc_sc[j].order-1] = oc_sc[j];
          }
          ordered_categories[i].sub_category = oc_osc;
        }
        //reordering question_categories based on order field in each question_categrory
        for(var i = 0; i< cl; i++){
          var oc_sc = ordered_categories[i].sub_category;
          for(var j = 0; j< oc_sc.length; j++){
            var qc = oc_sc[j].question_category;
            var oqc = [],oqc1 = [];
            for(var k = 0; k < qc.length; k++){
              oqc[qc[k].order-1] = qc[k];
            }
            var oqci=0;
            while(!oqc[oqci]) oqci++;
            for (var m=0; m < (oqc.length-oqci); m++)
              oqc1[m] = oqc[m+oqci];
            ordered_categories[i].sub_category[j].question_category = oqc1;
          }
        }
        for(var i = 0; i< cl; i++){
          var oc_sc = ordered_categories[i].sub_category;
          for(var j = 0; j< oc_sc.length; j++){
            var qc = oc_sc[j].question_category;
            for(var k = 0; k < qc.length; k++){
              var q = qc[k].question;
              var oq = [], oq1=[];
              for(var l = 0; l < q.length; l++){
                var qn = q[l];
                var idx = qn.question_grp * 3 + qn.order -1;
                oq[idx] = q[l];
              }
              var oqi=0;
              while(!oq[oqi]) oqi++;
              for (var m=0, n=0; m < (oq.length-oqi); m++)
              if(oq[m+oqi])
                oq1[n++] = oq[m+oqi];
              ordered_categories[i].sub_category[j].question_category[k].question = oq1;
            }
          }
        }
        data.category = ordered_categories;
        var cspans = {}, scspans = {}, qcspans = {};
        var rows1 = [];
        var cat_class = ['blue1','blue2'];
        var scat_class = ['blue3','blue4'];
        var measure_class = ['white','yellow'];

        for(var i = 1; i < data.category.length; i++){
          var cur_cat = data.category[i];
          cspans[cur_cat.id] = 0;

          for(var j = 0; j < cur_cat.sub_category.length; j++){
            var cur_scat = data.category[i].sub_category[j]
            scspans[cur_scat.id] = 0;

            for(var k = 0; k < cur_scat.question_category.length; k++){
              var cur_qcat = data.category[i].sub_category[j].question_category[k];
              qcspans[cur_qcat.id] = 0;
              var qcat_qtype = cur_qcat.question_type;
                  var qgroup = 0;

              for(var l = 0; l < cur_qcat.question.length; l++){
                var cur_ques = cur_qcat.question[l];
                  //map row index (question group) from questionairre sheet ordering to data sheet ordering
                var qgrp = cur_ques.question_grp;
                var dgrp = this.grp_map_qtod[qgrp.toString()];
                if(dgrp && !rows1[dgrp]){
                  //add a row indexed by question group as soon as the first question from this group is encountered
                  rows1[dgrp] = {
                    catid:cur_cat.id,
                    scatid:cur_scat.id,
                    cat:cur_cat.name,
                    scat:cur_scat.name,
                    qcat:cur_qcat.name,
                    cspan:0,
                    scspan:0,
                    measure:cur_ques.question_text,
                    unit2:'',
                    baseline:0,
                    current:0,
                    aspiration:0,
                    cat_class:cat_class[i%2],
                    scat_class:scat_class[i%2],
                    measure_class: measure_class[0]
                  }
                  //keep span values for each or c,sc and qc in separate objects
                  cspans[cur_cat.id]++;
                  scspans[cur_scat.id]++;
                  qcspans[cur_qcat.id]++;
                }
              }
            }
          }
        }
        var computed_rows = [1,2,4,6,8,15,23,27,34,36,40];
        for (var cr = 0; cr < computed_rows.length; cr++){
          var dgrp;
           dgrp = computed_rows[cr];
          //add a row indexed by question group as soon as the first question from this group is encountered
          rows1[dgrp] = {
            catid:null,
            scatid:null,
            cat:'',
            scat:'',
            qcat:'',
            cspan:0,
            scspan:0,
            measure:'',
            unit2:'',
            baseline:0,
            current:0,
            aspiration:0,
            cat_class:'',
            scat_class:'',
            measure_class: measure_class[1]
          }
        }

        for (var r = 1; r < rows1.length; r++){
          if(!rows1[r]) continue;
          //assign span values for category c, subcategory sc and quesion category qc when unused
          //(i.e. in the first row for each of c,sc and qc) and make them zero after using them once
          if(cspans[rows1[r].catid]){
            rows1[r].cspan = cspans[rows1[r].catid];
            cspans[rows1[r].catid] = 0;
          }
          if(scspans[rows1[r].scatid]){
            rows1[r].scspan = scspans[rows1[r].scatid];
            scspans[rows1[r].scatid] = 0;
          }
          if(qcspans[rows1[r].qcatid]){
            rows1[r].qcspan = qcspans[rows1[r].qcatid];
            qcspans[rows1[r].qcatid] = 0;
          }
        }

        rows1[1].cat = 'Supporting Information';
        rows1[1].cat_class = 'gray1';
        rows1[1].scat_class = 'gray1';
        rows1[2].measure_class = measure_class[0];

        rows1[1].measure = 'Year';
        rows1[2].measure = 'Total Population';
        rows1[4].measure = 'Proportion of population using safely managed drinking water services';
        rows1[6].measure = 'Proportion of population using improved sanitation services';
        rows1[8].measure = 'Proportion of population using a hygiene facility';
        rows1[15].measure = 'Proportion of water bodies with good ambient water quality';
        rows1[23].measure = 'Water-use efficiency';
        rows1[27].measure = 'Level of water stress';
        rows1[34].measure = 'Proportion of transboundary basin area with an operational arrangement for water cooperation';
        rows1[36].measure = 'Change in the area extent of water-related ecosystems';
        rows1[40].measure = 'Change in quantity of water contained within these ecosystems';

        rows1[1].cspan = 2;
        rows1[1].scspan = 2;
        rows1[3].cspan = 2;
        rows1[3].scspan = 2;
        rows1[5].cspan = 4;
        rows1[5].scspan = 4;
        rows1[9].cspan = 7;
        rows1[9].scspan = 4;
        rows1[13].scspan = 3;
        rows1[16].cspan = 12;
        rows1[16].scspan = 8;
        rows1[24].scspan = 4;
        rows1[28].cspan = 7;
        rows1[28].scspan = 4;
        rows1[32].scspan = 3;
        rows1[35].cspan = 6;
        rows1[35].scspan = 6;

        rows1[1].unit2 = '';
        rows1[2].unit2 = '000,000 people';
        rows1[3].unit2 = '000,000 people';
        rows1[4].unit2 = '%';
        rows1[5].unit2 = '000,000 people';
        rows1[6].unit2 = '%';
        rows1[7].unit2 = '000,000 people';
        rows1[8].unit2 = '%';
        rows1[9].unit2 = '%';
        rows1[10].unit2 = '%';
        rows1[11].unit2 = '%';
        rows1[12].unit2 = '%';
        rows1[13].unit2 = '#';
        rows1[14].unit2 = '#';
        rows1[15].unit2 = '%';
        rows1[16].unit2 = 'USD 000,000';
        rows1[17].unit2 = '000,000 m<sup>3</sup>';
        rows1[18].unit2 = 'USD 000,000';
        rows1[19].unit2 = '%';
        rows1[20].unit2 = '000,000 m<sup>3</sup>';
        rows1[21].unit2 = 'USD 000,000';
        rows1[22].unit2 = '000,000 m<sup>3</sup>';
        rows1[23].unit2 = 'USD/m<sup>3</sup>';
        rows1[24].unit2 = '10<sup>9</sup> m<sup>3</sup>';
        rows1[25].unit2 = '10<sup>9</sup> m<sup>3</sup>';
        rows1[26].unit2 = '10<sup>9</sup> m<sup>3</sup>';
        rows1[27].unit2 = '%';
        rows1[28].unit2 = 'score (1-100)';
        rows1[29].unit2 = 'score (1-100)';
        rows1[30].unit2 = 'score (1-100)';
        rows1[31].unit2 = 'score (1-100)';
        rows1[32].unit2 = 'km<sup>2</sup>';
        rows1[33].unit2 = 'km<sup>2</sup>';
        rows1[34].unit2 = '%';
        rows1[35].unit2 = 'km<sup>2</sup>';
        rows1[36].unit2 = '%';
        rows1[37].unit2 = '000,000 m<sup>3</sup>';
        rows1[38].unit2 = '000,000 m<sup>3</sup>';
        rows1[39].unit2 = '000,000 m<sup>3</sup>';
        rows1[40].unit2 = '%';

        observer.next(rows1);
        observer.complete();
      },
      error => {
          this.alertService.error(error);
      });
    });
  }

  calculateStatusResult(rows): Observable<any>{
    return Observable.create( observer => {
      this.results$ = this.resultService.getAll(COMP);
      this.results$.subscribe( data => {
        for(var i=0;i<data.length;i++){
          var res = data[i];
          //map row index (question group) from questionairre sheet ordering to data sheet ordering
          var qgrp = res.question_grp;
          var dgrp = this.grp_map_qtod[qgrp.toString()];
          if(dgrp){
          var f;
          if(res.value!=null && res.value!='')
            f = parseFloat(res.value);
          else
            f = res.value;
            if(res.question_type_order==1)
              rows[dgrp]['baseline'] = f;
            else if(res.question_type_order==2)
              rows[dgrp]['current'] = f;
            else if(res.question_type_order==3)
              rows[dgrp]['aspiration'] = f;
          }
          if (qgrp == 1)
          if(res.value!=null && res.value!='')
            rows[1]['baseline'] = parseInt(res.value);

          if (qgrp == 2)
          if(res.value!=null && res.value!='')
            rows[1]['current'] = parseInt(res.value);

          rows[1]['aspiration'] = 2030;
        }
        var rows1 = rows;

        //9(excel row) -5 = 4(data page group)
        //E9=100*E8/E7, F, G
        rows1[4].baseline = 100*rows1[3].baseline/rows1[2].baseline;
        rows1[4].current = 100*rows1[3].current/rows1[2].current;
        rows1[4].aspiration = 100*rows1[3].aspiration/rows1[2].aspiration;
        //E11=100*E10/E7, F, G
        rows1[6].baseline = 100*rows1[5].baseline/rows1[2].baseline;
        rows1[6].current = 100*rows1[5].current/rows1[2].current;
        rows1[6].aspiration = 100*rows1[5].aspiration/rows1[2].aspiration;
        //E13=100*E12/E7, F, G
        rows1[8].baseline = 100*rows1[7].baseline/rows1[2].baseline;
        rows1[8].current = 100*rows1[7].current/rows1[2].current;
        rows1[8].aspiration = 100*rows1[7].aspiration/rows1[2].aspiration;
        //E20=100*E18/E19, F, G
        rows1[15].baseline = 100*rows1[13].baseline/rows1[14].baseline;
        rows1[15].current = 100*rows1[13].current/rows1[14].current;
        rows1[15].aspiration = 100*rows1[13].aspiration/rows1[14].aspiration;

        //E28=(E23*(1-E24/100)/E25)*(E25/(E22+E25+E27))+(E21/E22)*(E22/(E22+E25+E27))+(E26/E27)*(E27/(E22+E25+E27))
        //F28=(F23*(1-F24/100)/F25)*(F25/(F22+F25+F27))+(F21/F22)*(F22/(F22+F25+F27))+(F26/F27)*(F27/(F22+F25+F27))
        //G28=(G23*(1-G24/100)/G25)*(G25/(G22+G25+G27))+(G21/G22)*(G22/(G22+G25+G27))+(G26/G27)*(G27/(G22+G25+G27))

        rows1[23].baseline = (rows1[18].baseline*(1-rows1[19].baseline/100)/rows1[20].baseline)*
        (rows1[20].baseline/(rows1[17].baseline+rows1[20].baseline+rows1[22].baseline))+
        (rows1[16].baseline/rows1[17].baseline)*
        (rows1[17].baseline/(rows1[17].baseline+rows1[20].baseline+rows1[22].baseline))+
        (rows1[21].baseline/rows1[22].baseline)*
        (rows1[22].baseline/(rows1[17].baseline+rows1[20].baseline+rows1[22].baseline));

        rows1[23].current = (rows1[18].current*(1-rows1[19].current/100)/rows1[20].current)*
        (rows1[20].current/(rows1[17].current+rows1[20].current+rows1[22].current))+
        (rows1[16].current/rows1[17].current)*
        (rows1[17].current/(rows1[17].current+rows1[20].current+rows1[22].current))+
        (rows1[21].current/rows1[22].current)*
        (rows1[22].current/(rows1[17].current+rows1[20].current+rows1[22].current));

        rows1[23].aspiration = (rows1[18].aspiration*(1-rows1[19].aspiration/100)/rows1[20].aspiration)*
        (rows1[20].aspiration/(rows1[17].aspiration+rows1[20].aspiration+rows1[22].aspiration))+
        (rows1[16].aspiration/rows1[17].aspiration)*
        (rows1[17].aspiration/(rows1[17].aspiration+rows1[20].aspiration+rows1[22].aspiration))+
        (rows1[21].aspiration/rows1[22].aspiration)*
        (rows1[22].aspiration/(rows1[17].aspiration+rows1[20].aspiration+rows1[22].aspiration));

        //E32=100*E30/(E29-E31), F, G
        rows1[27].baseline=100*rows1[25].baseline/(rows1[24].baseline-rows1[26].baseline);
        rows1[27].current=100*rows1[25].current/(rows1[24].current-rows1[26].current);
        rows1[27].aspiration=100*rows1[25].aspiration/(rows1[24].aspiration-rows1[26].aspiration);

        //E39=100*E37/E38
        rows1[34].baseline = 100*rows1[32].baseline/rows1[33].baseline;
        rows1[34].current = 100*rows1[32].current/rows1[33].current;
        rows1[34].aspiration = 100*rows1[32].aspiration/rows1[33].aspiration;

        //F41=100*(F40-E40)/E40
        //G41=100*((G40-E40)/E40)
        rows1[36].current=100*(rows1[35].current-rows1[35].baseline)/rows1[35].baseline;
        rows1[36].aspiration=100*((rows1[35].aspiration-rows1[35].baseline)/rows1[35].baseline);

        //F45=((F42+F43+F44)-(E42+E43+E44)/(E42+E43+E44))
        //G45=((G42+G43+G44)-(E42+E43+E44)/(E42+E43+E44))
        rows1[40].current =
        ((rows1[37].current+rows1[38].current+rows1[39].current)-
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline)/
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline));

        rows1[40].aspiration =
        ((rows1[37].aspiration+rows1[38].aspiration+rows1[39].aspiration)-
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline)/
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline));

        var computed_rows = [4,6,8,15,23,27,34,36,40];
        for (var cr = 0; cr < computed_rows.length; cr++){
          var dgrp;
           dgrp = computed_rows[cr];
          var val = rows1[dgrp].baseline;
          if(val==null || val == '-Infinity' || Number.isNaN(parseFloat(val)))
            val = "-";
          else if(val % 1 != 0)
            val = val.toFixed(1);
          rows1[dgrp].baseline = val;

          var val = rows1[dgrp].current;
          if(val==null || val == '-Infinity' || Number.isNaN(parseFloat(val)))
            val = "-";
          else if(val % 1 != 0)
            val = val.toFixed(1);
          rows1[dgrp].current = val;

          var val = rows1[dgrp].aspiration;
          if(val==null || val == '-Infinity' || Number.isNaN(parseFloat(val)))
            val = "-";
          else if(val % 1 != 0)
            val = val.toFixed(1);
          rows1[dgrp].aspiration = val;
        }

        rows1.splice(0,1);
        observer.next(rows1);
        observer.complete();
      },
      error => {
        this.alertService.error(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/status.service.ts